import getConfig from 'next/config';
import type { AxiosResponse } from 'axios';
import { IncomingHttpHeaders } from 'http';

import { donedealGateway } from '../api/api-utils/commonApiUtils';

import { IUpsellsResponse, Currency } from '../api/types/upsellsApiTypes';

const {
  publicRuntimeConfig: { API_LISTINGS_TIMEOUT },
} = getConfig();

async function getUpsells(
  adId: number,
  currency: Currency,
  section: number,
  photoCount: number,
  wanted: boolean,
  price: number,
  headers: IncomingHttpHeaders = { accept: 'application/json' },
): Promise<AxiosResponse<IUpsellsResponse[]>> {
  const response: AxiosResponse<IUpsellsResponse[]> =
    await donedealGateway.post(
      '/ddapi/v1/listings/upsells',
      {
        adId,
        currency,
        section,
        photoCount,
        wanted,
        price,
      },
      {
        headers,
        timeout: parseInt(API_LISTINGS_TIMEOUT),
      },
    );

  return response;
}

export const upsellsApi = { getUpsells };
